<template>
  <section>
    <router-link
        v-if="$_updateActionAllowed"
        class="tab_button tab_button_add" :title="'Přidat uživatele' | translate"
        :to="{ name: 'operatorUserNew', params: { operatorId: operatorId }}">
    </router-link>
    <popup v-show="hasPopupWithSpecification"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction">
    </popup>
    <div class="filter search_only">
      <div class="field_left">
        <search-input input-class="search" v-model="formFields.search"></search-input>
      </div>
    </div>
    <div class="scroll-wrapper">
      <div class="table_overflow" id="contentBox" data-table-id="operators-users">
        <table class="vypis vypis_detail" ref="table_with_action_line" v-show="dataLoaded">
          <thead>
          <tr v-if="entities.length > 0">
            <th class="no_padding drag_drop"></th>
            <th class="no_padding checkbox"></th>
            <sorting-table-title
                v-for="title in sortingTableTitles"
                :key="title.id"
                :column="title.column"
                :sort="getActiveSort(title.column)"
                @changeSorting="changeSorting">{{ title.name }}
            </sorting-table-title>
            <th class="no_padding edit"></th>
          </tr>
          </thead>
          <tbody>
          <user-row
              v-for="user in entities"
              :user="user"
              :key="user.id"
              :selectedUsers="selectedEntities"
              :show-operator="!operatorId"
              @input="select"
              @updateUser="updateEntity"
              @deleteUser="deleteEntity"
          ></user-row>
            <tr v-if="entities.length === 0">
                 <td colspan="8">{{ $gettext('Nebyli nalezeni žádní uživatelé.') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <list-action-line
        :entities="filteredOtherUsers"
        :selected-entities="filteredSelectedEntities"
        :multiple-action-options="(multipleActionOptions)"
        :offset="formFields.offset"
        :limit="formFields.limit"
        :total-count="totalCount"
        table-id="operators-users"
        @select-all="toggleSelectAll"
        @run-multiple-action="runMultipleAction"
        @limit="setLimit"
        @offset="setOffset"
        ref="action_line"
    ></list-action-line>
  </section>
</template>

<script>
	import Popup from "@/components/common/Popup"
	import UserRow from "@/components/views/users/UserRow"
	import SortingTableTitle from "@/components/common/SortingTableTitle"

	import listActions from "@/components/mixins/list-actions"

	export default {
		name: "UserListTable",
		components: {Popup, UserRow, SortingTableTitle},
		mixins: [listActions],
		props: {
			operatorId: [String, Number],
      readOnlyMode: {
				type: Boolean,
        default: false,
      }
		},
		data() {
			return {
				moduleName: 'users',
			}
		},
		mounted(UserService) {
			this.entityService = UserService
      if(this.operatorId){;
        this.formFields.id_selected_operator = this.operatorId;
      }
			this.createdInit()
		},
		computed: {
			multipleActionOptions() {
        let options = [
					{value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
				];
        if(this.$_updateActionAllowed){
          options.push({value: 'activate', text: this.$gettext('Aktivovat')});
          options.push({value: 'deactivate', text: this.$gettext('Deaktivovat')});
        }
        if(this.$_deleteActionAllowed){
          options.push({value: 'delete', text: this.$gettext('Smazat')});
        }

        return options;
			},
			sortingTableTitlesOperator() {
				return [
					{id: 1, name: this.$gettext('Příjmení jméno'), column: 'sName'},
					{id: 2, name: this.$gettext('Role'), column: 'sRole'},
					{id: 3, name: this.$gettext('Vloženo'), column: 'sDateCreated'},
					{id: 4, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
				]
			},
			sortingTableTitlesOwner() {
				return [
					{id: 1, name: this.$gettext('Příjmení jméno'), column: 'sName'},
					{id: 2, name: this.$gettext('Role'), column: 'sRole'},
					{id: 3, name: this.$gettext('Operátor'), column: 'sOperatorName'},
					{id: 4, name: this.$gettext('Vloženo'), column: 'sDateCreated'},
					{id: 5, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
				]
			},
      csvHeaders(){
        let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
        headers.role.callback = entity => {
          let roleName = ''
          if (entity.role === 'ROLE_OPERATOR') {
            roleName = this.$gettext('Operátor')
          }
          if (entity.role === 'ROLE_OWNER') {
            roleName = this.$gettext('Majitel')
          }
          return roleName
        };

        return headers;
      },
			hasPopupWithSpecification() {
				return this.hasPopup && this.getPopupSpecification === 'user'
			},
			filteredSelectedEntities() {
				let filteredAndSelected = []
				this._.forEach(this.entities, function (filteredUser) {
					if (this._.includes(this.selectedEntities, String(filteredUser['id']))) {
						if (String(filteredUser['id']) !== String(this.$store.getters.getLoggedUserId)) {
							filteredAndSelected.push(String(filteredUser['id']))
						}
					}
				}.bind(this))

				return filteredAndSelected
			},
			filteredOtherUsers() { // except logged in user
				let filteredOtherUsers = []
				this._.forEach(this.entities, function (filteredOtherUser) {
					if (String(filteredOtherUser['id']) !== String(this.$store.getters.getLoggedUserId)) {
						filteredOtherUsers.push(String(filteredOtherUser['id']))
					}
				}.bind(this))

				return filteredOtherUsers
			},
			sortingTableTitles() {
				if (!this.operatorId) {
					return this.sortingTableTitlesOwner
				} else {
					return this.sortingTableTitlesOperator
				}
			}
		},
		methods: {
			getEntities() {
				this.setLoadingMessage()
					this.entityService.getEntities(this._processFormFields(this.getFormFields()))
						.then(data => {
							this.dataLoaded = true
							this.entities = data[this.moduleName]
							this.totalCount = Number(data['totalCount'])
							this.emptyMessage()
						})
						.catch(error => {
							this.setErrorMessage(error['error_message'])
						})
			},
      _exportCsv(){
        this.setLoadingMessage()
        let formFields = this._processFormFields(this.getFormFields());
        delete formFields.limit;
        delete formFields.offset;
        if (!this.readOnlyMode) {
          this._processGetEntitiesCsvResponse(
              this.entityService.getEntities(this.operatorId, formFields),
              this.csvHeaders
          )
        } else {
          this._processGetEntitiesCsvResponse(this.entityService.getEntities(formFields), this.csvHeaders)
        }
      },
			toggleSelectAll(value) {
				let selected = []
				if (value) {
					this.entities.forEach(function (entity) {
						if (String(entity.id) !== String(this.$store.getters.getLoggedUserId)) {
							selected.push(String(entity.id))
						}
					}.bind(this))
				}
				this.selectedEntities = selected
			},
			deleteEntity(id, showPopup = true) {
				if (showPopup) {
					if (this._.includes(id, ',')) {
						this.showPopup(id, 'delete-multi', 'delete-multi', 'user')
					} else {
						this.showPopup(id, 'delete', 'delete', 'user')
					}
				} else {
					this.entityService.deleteEntity(id)
						.then(() => {
							this.setSuccessMessage()
							this.selectedEntities = []
							this.keepOffset = true
							this.getEntities()
						})
						.catch(error => {
							this.setErrorMessage(error['error_message'])
						})
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/operators/UserListTable.vue